import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer = () => (
  <footer
    className="border-t border-line bg-cream mt-24"
    data-testid="site-footer"
  >
    <div className="max-w-6xl mx-auto px-6 py-12 flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
      <div className="max-w-sm">
        <Link to="/" aria-label="Summaros home" className="inline-flex">
          <Logo variant="compact" testid="footer-brand-logo" />
        </Link>
        <p className="mt-4 text-sm text-ink-muted leading-relaxed">
          A quiet place to look at your life. Private by default.
        </p>
      </div>

      <nav
        className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-ink-muted"
        data-testid="footer-nav"
      >
        <Link to="/assess" className="hover:text-forest transition-colors" data-testid="footer-assess-link">
          Life Assessment
        </Link>
        <Link to="/community" className="hover:text-forest transition-colors" data-testid="footer-community-link">
          Community
        </Link>
        <Link to="/ask" className="hover:text-forest transition-colors" data-testid="footer-ask-link">
          Ask Summaros
        </Link>
      </nav>

      <p className="text-xs text-ink-faint">
        &copy; {new Date().getFullYear()} Summaros
      </p>
    </div>
  </footer>
);

export default Footer;
